import script from "./commonConfirmDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./commonConfirmDialog.vue?vue&type=script&lang=ts&setup=true"

import "./commonConfirmDialog.vue?vue&type=style&index=0&id=2d5dab92&lang=less"

const __exports__ = script;

export default __exports__